import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import AppButton from 'components/FormsUI/AppButton/appButton';

export default function DocTypeRow({ item, onEdit, onSubmitted }) {
    const [message, setMessage] = useState("");
    const [selectedItem, setSelectedItem] = useState({});
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = (item, action) => {
        setMessage('Are you sure you want to delete the doc?');
        setSelectedItem(item);
        setShow(true);
    }
    const HandleDeleteUser = async () => {
        onSubmitted(selectedItem, "delete");
        setShow(false);
    }
    return (

        <div key={item?.id} className="row paddingLeftRight align-items-c border-bottom" >
            <div className="col-md-2">
                {item?.docTypeMrz}
            </div>
            <div className="col-md-2">
                {item?.description}
            </div>
            <div className="col-md-2">
                <AppButton action={onEdit} label="Update" ></AppButton>
                <AppButton action={() => handleShow(item, "cancel")} label="Delete" ></AppButton>
            </div>

            <div>
                <Modal show={show} >
                    <Modal.Header>
                        <Modal.Title>Delete DocType</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{message}</Modal.Body>
                    <Modal.Footer>
                        <div className='col-2'>
                            <AppButton action={() => HandleDeleteUser(selectedItem)} label="Yes" isBlock={true}></AppButton>
                        </div>
                        <div className='col-2'>
                            <AppButton action={handleClose} label="No" color="secondary" isBlock={true}></AppButton>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}